<template>
    <div>
        <navbar :title="text"></navbar>
        <div class="videos" v-for="item in list" :key="item.img">
            <a :href="item.url">
                <img :src="item.img" alt="">
            </a>
        </div>
    </div>
</template>

<script>
import navbar from '../../components/Navbar'
export default {
    components:{
        navbar
    },      
    data(){
        return{
            text:'专题课程',
            list:[      
                {img:'https://img.qiaoxuesi.com/market/outImg/1587717418096.JPG',url:'https://lubo.gankao.com/tag/xxastfs'},     
                {img:'https://img.qiaoxuesi.com/market/outImg/1541055361844.JPG',url:'https://lubo.gankao.com/tag/free1'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540881644399.JPG',url:'https://lubo.gankao.com/tag/jtjy'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540871345005.JPG',url:'https://lubo.gankao.com/tag/letsgo'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1589177204597.PNG',url:'https://lubo.gankao.com/tag/mschool'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540889078162.JPG',url:'https://lubo.gankao.com/tag/guoxue'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540890224577.JPG',url:'https://lubo.gankao.com/tag/ywzw'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540890254443.JPG',url:'https://lubo.gankao.com/tag/czkc'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540872079930.JPG',url:'https://lubo.gankao.com/tag/xiaoxuetingxieben'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1544497381934.JPG',url:'https://lubo.gankao.com/tag/tbsz'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540882237000.JPG',url:'https://lubo.gankao.com/tag/anquanchangshi'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540888186653.JPG',url:'https://lubo.gankao.com/tag/ciyutingxie'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1540884102903.JPG',url:'https://lubo.gankao.com/tag/langdu'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1562913536462.JPG',url:'https://lubo.gankao.com/tag/mjtg'},
                {img:'https://img.qiaoxuesi.com/market/outImg/1589177004296.PNG',url:'https://lubo.gankao.com/tag/schoolcourse'},
            ],
        }
    },
}
</script>

<style scoped>
.videos{
    padding: 0 0.4rem 5px;
}
.videos img{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/courseDetails/courseDetails.vue